import * as React from 'react';
import EventMg, { EventType } from '../utilities/EventManager';

import { CONFERENCE_MODE } from '../utilities/constants';

export class ToggleConference extends React.Component {
  constructor(props) {
    super(props);

    // 0,1で格納している値をboolに変換
    const isConference =
      sessionStorage.getItem('is_conference') === CONFERENCE_MODE.on.key;

    this.state = {
      isConference,
    };

    this.handleToggleConference = this.handleToggleConference.bind(this);
  }
  componentDidMount() {
    const { isConference } = this.state;
    if (isConference) {
      EventMg.trigger(EventType.CONFERENCE_MODE, isConference);
    }
  }

  handleToggleConference = () => {
    const { isConference } = this.state;
    this.setState({ isConference: !isConference });
    sessionStorage.setItem(
      'is_conference',
      isConference ? CONFERENCE_MODE.off.id : CONFERENCE_MODE.on.id
    );
    EventMg.trigger(EventType.CONFERENCE_MODE, !isConference);
  };

  render() {
    return (
      <div className='global-header__conference'>
        <span className='gloabl-header__label'>
          <span>会議</span>
          <var>{this.state.isConference ? 'ON' : 'OFF'}</var>
        </span>
        <label htmlFor='toggle-header' className='toggle'>
          <input
            type='checkbox'
            checked={this.state.isConference}
            id='toggle-header'
            onChange={this.handleToggleConference}
          />
          <div className='toggle__item' />
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ToggleConference.jsx